







































































































import Vue from 'vue'
import resetForm from '@morpheus/utils/admin-vue/helpers/resetForm'
import { regexUri, regexVersion } from '@morpheus/utils/admin-vue/helpers/regex'
import { versionsApplicationList, versionsPlatformList } from '../services/versions-client'

export default Vue.extend({
  name: 'VersionsForm',
  props: {
    formId: {
      required: true,
      type: String
    },
    editedItem: {
      required: false,
      type: Object,
      default: () => ({})
    },
    btnLabel: {
      required: false,
      type: String,
      default: 'Submit'
    },
    isLoading: {
      required: false,
      type: Boolean,
      default: false
    },
    triggerClear: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      regex: {
        version: regexVersion,
        uri: regexUri
      },
      applicationList: versionsApplicationList,
      platformList: versionsPlatformList,
      version: {
        application: 'Client',
        bundle_name: '',
        platform: '',
        enabled: false,
        version: '',
        min_version: '',
        download_url: '',
        api_base_uri: '',
        patch_notes: ''
      }
    }
  },
  watch: {
    triggerClear (val: boolean) {
      if (val) {
        this.clear()
      }
    }
  },
  mounted () {
    for (var prop in this.editedItem) {
      if (this.editedItem.hasOwnProperty(prop)) {
        Vue.set(this.version, prop, this.editedItem[prop])
      }
    }
  },
  methods: {
    submit () {
      this.$validator.validateAll()
        .then((result) => {
          if (result) {
            const version = {
              application: this.version.application,
              bundle_name: this.version.bundle_name,
              platform: this.version.platform,
              enabled: this.version.enabled,
              version: this.version.version,
              min_version: this.version.min_version,
              download_url: this.version.download_url,
              api_base_uri: this.version.api_base_uri,
              patch_notes: this.version.patch_notes
            }
            this.$emit('onSubmit', version)
          }
        })
    },
    clear () {
      resetForm(this.version)
      this.$validator.reset()
      this.$emit('onClearForm')
    }
  }
})
